import { useLocation, useNavigate } from "react-router-dom";

declare global {
  interface Window {
    grained: any;
  }
}

export const useApp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return { navigate, location };
};
